/** Shared SVG <defs> — shadow, surface patterns, floor gradient. Mount once. */
export function FloorPlanDefs() {
  return (
    <defs>
      <filter id="fp-shadow" x="-30%" y="-30%" width="160%" height="160%">
        <feDropShadow dx="0" dy="3" stdDeviation="4" floodColor="#000" floodOpacity="0.5" />
      </filter>

      <radialGradient id="fp-floor-bg" cx="50%" cy="38%" r="78%">
        <stop offset="0%" stopColor="var(--charcoal-850)" />
        <stop offset="100%" stopColor="var(--charcoal-950)" />
      </radialGradient>

      <linearGradient id="fp-stage" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="var(--charcoal-700)" />
        <stop offset="100%" stopColor="var(--charcoal-850)" />
      </linearGradient>

      {/* Dance-floor checker */}
      <pattern id="fp-dance" width="44" height="44" patternUnits="userSpaceOnUse">
        <rect width="22" height="22" fill="var(--cream)" opacity="0.05" />
        <rect x="22" y="22" width="22" height="22" fill="var(--cream)" opacity="0.05" />
      </pattern>

      {/* Bar counter hatch */}
      <pattern
        id="fp-bar"
        width="13"
        height="13"
        patternUnits="userSpaceOnUse"
        patternTransform="rotate(45)"
      >
        <rect width="13" height="13" fill="var(--charcoal-800)" />
        <line
          x1="0"
          y1="0"
          x2="0"
          y2="13"
          stroke="var(--gold-soft)"
          strokeOpacity="0.22"
          strokeWidth="2"
        />
      </pattern>
    </defs>
  );
}
